import React, { ReactNode } from 'react';
import Preloader from '../Preloader/Preloader';
import styles from './ContentPlaceholder.module.scss';
import classNames from 'classnames';

interface Props {
  isLoading?: boolean;
  doesContentExist?: boolean;
  noContentTitle?: string;
  height?: number | string;
  width?: number | string;
  children?: ReactNode;
  contentClassName?: string;
  noContentClassName?: string;
  loaderClassName?: string;
}

const ContentPlaceholder = ({
  isLoading = false,
  doesContentExist = true,
  loaderClassName,
  noContentClassName,
  noContentTitle,
  height = '100%',
  width = '100%',
  children,
  contentClassName,
}: Props) => {
  if (isLoading) {
    return (
      <div
        style={{ width, height }}
        className={classNames(styles.loadingContainer, loaderClassName)}
      >
        <Preloader />
      </div>
    );
  }

  if (!doesContentExist) {
    return (
      <div
        className={classNames(
          styles.noContentContainer,
          styles.noContentClassName,
        )}
        style={{ width, height }}
      >
        {noContentTitle}
      </div>
    );
  }

  if (!children) return null;

  return (
    <span
      className={classNames(
        styles.fadeInAnimation,
        styles.contentContainer,
        contentClassName,
      )}
    >
      {children}
    </span>
  );
};

export default ContentPlaceholder;
